<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/launch-page-activity/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="编号"
                         min-width="90"></el-table-column>
        <el-table-column prop="title"
                         label="活动名称"
                         min-width="120"></el-table-column>
        <el-table-column prop="starttime"
                         label="开始时间-结束时间"
                         width="190">
          <template slot-scope="scope">
            {{scope.row.starttime}} - {{scope.row.endtime}}
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="创建人"
                         width="190"></el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         width="190">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="item.value === scope.row.status">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/launch-page-activity/detail/${scope.row.id}`">
                <el-button size="mini" v-if="scope.row.status === 1">查看</el-button>
              </router-link>
              <el-button type="primary"
                         size="mini"
                         v-if="scope.row.status === 0 || scope.row.status === 2 "
                         @click="onRelease(scope.row.id)">发布
              </el-button>

              <el-button type="primary"
                         size="mini"
                         v-if="scope.row.status === 1"
                         @click="onOffline(scope.row.id)">下线
              </el-button>
              <router-link :to="`/launch-page-activity/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary"
                           v-if="scope.row.status !== 1">编辑
                </el-button>
              </router-link>

              <el-button type="danger"
                         size="mini"
                         v-if="scope.row.status !== 1"
                         @click="onDelete(scope.$index, table)">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../launch-page-activity.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      },
    }
  },
  computed: Vuex.mapState({
    options: state => state.launchPageActivity.options,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getLaunchPageActivityTable', params)
    },
    onDelete (index, rows) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteLaunchPageActivityData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    onOffline (id) {
      this.$confirm('你确定要下线活动吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('offlineLaunchPageActivityData', {id: id}).then((res) => {
          this.$message({
            showClose: true,
            message: '下线成功',
            type: 'success',
          })
          this.onSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下线',
        })
      })
    },


    onRelease (id) {
      this.$confirm('你确定要发布活动吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('onlineLaunchPageActivityData', {id: id}).then((res) => {
          this.$message({
            showClose: true,
            message: '发布成功',
            type: 'success',
          })
          this.onSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消发布',
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/launch-page-activity/pages/LaunchPageActivityTable.vue